import React from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';

interface DropdownItem {
    val: string;
    label: string;
}
interface SearchBySplitInputProps {
    dropdownId: string;
    inputId: string;
    dropdownItems: DropdownItem[];
    onDropdownChange: (x: DropdownItem) => void;
    onInputChange: (e: React.FormEvent<HTMLInputElement>) => void;
}
function SearchBySplitInput({
    dropdownId,
    inputId,
    dropdownItems,
    onDropdownChange,
    onInputChange,
}: SearchBySplitInputProps) {
    const [selectedDropdown, setSelectedDropdown] = React.useState(dropdownItems[0]);

    function handleDropdownChanged(eventKey: string) {
        const idx = parseInt(eventKey);
        setSelectedDropdown(dropdownItems[idx]);
        onDropdownChange(dropdownItems[idx]);
    }

    return (
        <div className="input-group search-by-split-input">
            <div className="input-group-prepend">
                <DropdownButton
                    id={dropdownId}
                    title={selectedDropdown?.label}
                    onSelect={handleDropdownChanged}
                    variant="outline-secondary"
                    menuRole="listbox"
                >
                    {dropdownItems.map((item, idx) => (
                        <Dropdown.Item key={item.val} eventKey={idx} role="option">
                            {item.label}
                        </Dropdown.Item>
                    ))}
                </DropdownButton>
            </div>
            <input
                type="text"
                id={inputId}
                aria-label={inputId}
                className="form-control"
                onChange={onInputChange}
            />
            <div className="input-group-append">
                <button type="submit" className="btn btn-primary">
                    Search
                </button>
            </div>
        </div>
    );
}

export { SearchBySplitInput };
